module.exports = __webpack_public_path__ + "img/added-service-unit-10.4e147a28.png";